import React, {useContext, useEffect} from 'react'
import Layout from '../../../components/layout/layout'
import './aiDepressive.scss'
import depression1 from '../../../images/articles/depression1.jpg'
import depression2 from '../../../images/articles/depression2.jpg'
import depression3 from '../../../images/articles/depression3.jpg'
import depression4 from '../../../images/articles/depression4.jpg'
import aidepressivemain from '../../../images/articles/aidepressivemain.jpg'
import { LanguageContext } from '../../../components/LanguageSwitcher/LanguageContext'
import { ArticleBackLink, ArticleNextCta } from '../../../components/ArticleNav/ArticleNav'
import ArticleCta from '../../../components/ArticleCta/ArticleCta'
import ArticleListen from '../../../components/ArticleListen/ArticleListen'
import ArticleSummary from '../../../components/ArticleSummary/ArticleSummary'
import Seo, { articleJsonLd, articleBreadcrumbs } from '../../../components/Seo/Seo'



const AiDepressive = () => {
  const { translations } = useContext(LanguageContext);

  useEffect(() => {
    window.scrollTo(0, 0); 
  }, []);

  return (
    <Layout>
      <Seo
        title='Wearables in Depression Care: A Builder’s Guide'
        description={translations.Blogaidepressivemain1}
        type='article'
        image={depression1}
        jsonLd={[
          articleJsonLd({ headline: translations.Blogaidepressivemain, description: translations.Blogaidepressivemain1, datePublished: '2025-01-19', dateModified: '2026-09-18', author: translations.Blogaidepressivemain20 }),
          articleBreadcrumbs(translations.Blogaidepressivemain, '/articles/aiDepressive'),
        ]}
      />
      <div className='mlrole-health-container'>
        <div className='mlrole-health healthh-box'>
          <ArticleBackLink />
          <h1 className='article-main-title'>{translations.Blogaidepressivemain}</h1>
          <div className='article-author-head-container'>
            <div className='article-author-head'>
              <p>{translations.Blogaidepressivemain19}</p>
              <p>•</p>
              <p>{translations.Blogaidepressivemain20}</p>
            </div>
            <p className='article-author-head'>{translations.Blogaidepressivemain21}</p>
          </div>

          <div className='mlrole-health-first-image-box'>
            <img src={aidepressivemain} alt='aidepressivemain' className='mlrole-health-first-image' />
          </div>
          <ArticleListen />
          <ArticleSummary id='aiDepressive' />
          <div className='mlrole-health-txt-container'>
            <div className='mlrole-health-txt-child-box'>
              <p>{translations.Blogaidepressivemain1}</p>
              <p>{translations.Blogaidepressivemain2}</p>
              <p>{translations.Blogaidepressivemain3}</p>
              <p>{translations.Blogaidepressivemain4}</p>
              <p>{translations.Blogaidepressivemain5}</p>
              <p>{translations.Blogaidepressivemain6}</p>
              <p>{translations.Blogaidepressivemain7}</p>
              <p>{translations.Blogaidepressivemain8}</p>
              <img src={depression1} alt='depression1' className='mlroleHealthImage2' />
              <h2 className='article-secondaty-title depressive-title'>{translations.Blogaidepressivemain9}</h2>
              <p>{translations.Blogaidepressivemain10}</p>
              <p>{translations.Blogaidepressivemain11}</p>

              <h2 className='article-secondaty-title depressive-title'>{translations.Blogaidepressivemain12}</h2>
              <p>{translations.Blogaidepressivemain13}</p>
              <img src={depression2} alt='depression1' className='mlroleHealthImage2' />

              <p>{translations.Blogaidepressivemain14}</p>
              <p>{translations.Blogaidepressivemain15}</p>
              <img src={depression3} alt='depression1' className='mlroleHealthImage2' />

              <p>{translations.Blogaidepressivemain16}</p>
              <p>{translations.Blogaidepressivemain17}</p>
              <img src={depression4} alt='depression1' className='mlroleHealthImage2' />

              <p></p>

            </div>
          </div>

          <ArticleCta />
          <ArticleNextCta link='/articles/mlOutRails' title={translations.BlogmlFails} />
        </div>
      </div>
    </Layout>
  )
}

export default AiDepressive